var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7192 43.3423L33.947 41.2979",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9507 41.3001L70.9679 36.6362",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7728 42.9727L18.5278 49.681",
    stroke: "#444444",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3653 64.5163C30.1296 64.5163 31.5598 63.0861 31.5598 61.3219C31.5598 59.5576 30.1296 58.1274 28.3653 58.1274C26.6011 58.1274 25.1709 59.5576 25.1709 61.3219C25.1709 63.0861 26.6011 64.5163 28.3653 64.5163Z",
    fill: "#0099CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6984 59.1616L55.775 59.8005L40.7228 61.6916C40.7011 61.6918 40.6801 61.6842 40.6637 61.6701C40.6472 61.656 40.6364 61.6364 40.6334 61.6149L40.02 56.7083C40.02 56.7083 40.02 56.6316 40.0839 56.6188L53.1811 54.9449L55.1361 54.7021L55.6984 59.1616Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2669 58.2038L68.6153 53.0288L64.0919 53.6038L59.5303 54.1788L60.1819 59.3538L69.2669 58.2038Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9509 27.9971L67.312 22.9243",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9922 29.2495L74.3272 24.9434",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3989 32.5979L77.4717 31.959",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5644 34.7686L18.9972 36.0464C18.7144 36.0795 18.441 36.1686 18.1929 36.3083C17.9449 36.4481 17.7271 36.6358 17.5523 36.8606C17.3775 37.0853 17.2491 37.3426 17.1747 37.6175C17.1003 37.8923 17.0813 38.1792 17.1188 38.4614L20.7222 67.122C20.7954 67.6928 21.0923 68.2112 21.5475 68.5634C22.0026 68.9156 22.579 69.0727 23.1499 69.0003L55.861 64.8859L61.5344 64.1703L72.0888 62.8925C72.3709 62.8578 72.6434 62.7677 72.8906 62.6274C73.1378 62.4871 73.3549 62.2994 73.5294 62.075C73.704 61.8507 73.8324 61.5941 73.9076 61.3199C73.9827 61.0458 74.0029 60.7595 73.9672 60.4775L70.3638 31.8042C70.2904 31.2359 69.9954 30.7196 69.5431 30.3677C69.0908 30.0159 68.5177 29.8571 67.9488 29.9259L28.261 34.922",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCard);
export default __webpack_public_path__ + "static/media/ico_card.ae1c24eb7fb9d0911145d3fe61f403f7.svg";
export { ForwardRef as ReactComponent };